import { VirtualList } from '@epam/promo';
import { useNavigate } from 'react-router-dom';
import { broadcastRoutes } from 'router/broadcastRoutes';
import { Broadcast } from 'models/broadcast.model';
import { useBroadcastStore } from 'store/broadcast';
import { useAppLocation } from 'hooks/helpers';
import { useBroadcastDeleteQuery, useBroadcastSwitcher, useModal } from 'hooks';
import { validateHTML } from 'hooks/helpers/common';
import { Card } from '../card';
import css from './CardList.module.scss';

export const CardList = ({ items }: { items: Broadcast[] }) => {
  const modal = useModal();
  const { isNotFound } = useAppLocation(broadcastRoutes);
  const navigate = useNavigate();
  const switchBroadcast = useBroadcastSwitcher();
  const draft = useBroadcastStore((state) => state.draft);

  const { mutate: deleteBroadcast, discardDraft } = useBroadcastDeleteQuery();

  return (
    <VirtualList
      cx={[css.list, css.input__container]}
      role="listbox"
      rows={
        items.map((item) => (
          <Card
            key={item.id}
            isActive={item.id === draft.id}
            item={item}
            onClick={() => {
              if (item.id !== draft.id || isNotFound)
                switchBroadcast({
                  onSuccess: () =>
                    navigate(broadcastRoutes.broadcastId(item.id)),
                  onAbort: () => navigate(broadcastRoutes.broadcastId(item.id)),
                });
            }}
            onDelete={() =>
              item.id
                ? modal.delete({
                    text: `Are you sure you want to Delete ${
                      item.title
                        ? `"${validateHTML(item.title)}"`
                        : 'this broadcast'
                    }?`,
                    highlights: [
                      `${
                        item.title
                          ? `"${validateHTML(item.title)}"`
                          : 'this broadcast'
                      }`,
                      'Delete',
                    ],
                    onSuccess: () => deleteBroadcast(item.id),
                  })
                : modal.delete({
                    text: 'Are you sure you want to Delete this draft?',
                    highlights: ['Delete', 'draft'],
                    onSuccess: () => discardDraft(),
                  })
            }
          />
        )) || []
      }
      rowsCount={items.length}
      value={{ topIndex: 0 }}
      onValueChange={() => {}}
    />
  );
};
